<template>
<div class="about text-left">
    <div class="title-content text-container">
      <h2>Contato</h2>
      <p>A <a href="https://www.sarah.br" target="_blank">Rede SARAH</a> de Hospitais de Reabilitação é uma instituição pública, sediada em 8 capitais brasileiras. </p>
    <br/>

      <div v-for="(contato, idx) in contatos" v-bind:key="idx">
        <div class="text-left text-lg font-bold">
          {{ contato.desc }}
        </div>
        <!-- <div class="text-left text-lg font-base caption mt-1 mb-4"><a :href="`mailto:${contato.mail}`">{{ contato.mail }}</a></div> -->
      </div>

      <br/>

      <p>
        Para outras informações sobre a Rede SARAH de Hospitais de Reabilitação acesse: <br/>
        <a href="https://www.sarah.br" target="_blank">www.sarah.br</a> <br/><br/>

        Ou entre em contato: 
        <span class="text-left text-lg font-base caption mt-1 mb-4"><a href="mailto:prevencao@sarah.br">prevencao@sarah.br</a></span>
      </p>

    </div>
    
    <img class="hidden md:block" alt="Garoto dando sinal de vida na faixa de pedestres" src="../assets/cuidados/sinal_faixa.png" style="position: absolute; right: 100px; top: 90px; width: 630px; max-width: 50%;">
  </div>
</template>

<script>
export default {
  data() {
    return {
      contatos: [
        { desc: 'SARAH Belém', mail: 'prevencaobel@sarah.br' },
        { desc: 'SARAH Belo Horizonte', mail: 'bhzprevencao@sarah.br' },
        { desc: 'SARAH Brasília', mail: 'prevencao@sarah.br' },
        { desc: 'SARAH Fortaleza', mail: 'prevencaofor@sarah.br' },
        { desc: 'SARAH Rio de Janeiro', mail: 'prevencaorio@sarah.br' },
        { desc: 'SARAH Salvador', mail: 'prevencaossa@sarah.br' },
        { desc: 'SARAH São Luís', mail: 'prevencaoslz@sarah.br' },
        { desc: 'SARAH Macapá', mail: 'prevencaomcp@sarah.br' },
      ]
    }
  }
}
</script>

<style scoped>
p {
  margin-top: 1rem;
}

.text-container {
  width: 100%;
}

@media (min-width: 768px) {
  .text-container {
    width: 60%;
  }
}
</style>